import { render, staticRenderFns } from "./GoodsTagList.vue?vue&type=template&id=177bb89c&scoped=true&"
import script from "./GoodsTagList.vue?vue&type=script&lang=js&"
export * from "./GoodsTagList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "177bb89c",
  null
  
)

export default component.exports